import { Result } from 'antd';

import OperondaLogo from '@src/components/OperondaLogo';
import { useVisualViewportInset } from '@src/packages/utils';
import IntlMessages from '@src/util/IntlMessages';

import LocationAlertForm from '../../components/LocationAlertForm';
import LocationAlertSuccessful from '../../components/LocationAlertSuccessful';
import { FORM_STATUS } from '../../constants';
import { usePublicLocationAlert } from './hooks/usePublicLocationAlert';
import styles from './styles.module.less';

const LocationAlert = () => {
  useVisualViewportInset();
  const { formStatus, loading, missingContext, onChangeDescription, onSendForm } =
    usePublicLocationAlert();

  return (
    <div className={styles.page}>
      <div className={styles.shell}>
        <header className={styles.header}>
          <OperondaLogo />
        </header>
        <main className={styles.main}>
          {missingContext ? (
            <div className={styles.errorState}>
              <Result
                status="warning"
                title={<IntlMessages id="location.alert.error.title" />}
                subTitle={<IntlMessages id="location.alert.error.missing.params" />}
              />
            </div>
          ) : formStatus !== FORM_STATUS.SUBMITTED ? (
            <LocationAlertForm
              loading={loading}
              onChange={onChangeDescription}
              onSubmit={onSendForm}
            />
          ) : (
            <LocationAlertSuccessful />
          )}
        </main>
      </div>
    </div>
  );
};

export default LocationAlert;
